import React from 'react';

export default function SensorCard({ title, value, icon: Icon, color, progress, max }) {
    return (
        <div className="sensor-card glass-effect">
            <Icon className="sensor-icon" color={color} size={28} />
            <h3>{title}</h3>
            <div className="sensor-value">{value}</div>

            {progress !== undefined && (
                <div className="progress-bar">
                    <div
                        className="progress-fill"
                        style={{ width: `${Math.min(100, (progress / max) * 100)}%` }}
                    ></div>
                </div>
            )}
        </div>
    );
}
